// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// In-memory storage: o app usa JWTs customizados (não emitidos pelo GoTrue),
// então persistir no localStorage causa 403 em /auth/v1/user a cada page reload.
// A sessão é restaurada automaticamente via ensureSupabaseSession / getAdminToken.
const _mem: Record<string, string> = {};
const memoryStorage = {
  getItem: (key: string) => _mem[key] ?? null,
  setItem: (key: string, value: string) => { _mem[key] = value; },
  removeItem: (key: string) => { delete _mem[key]; },
};

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: memoryStorage,
    persistSession: true,
    autoRefreshToken: false,
  }
});